module.exports = __webpack_public_path__ + "static/media/emptyState.4661895d.png";